import { ArticleCard } from '../components/ArticleCard'
import { articles } from '../content/site'

export function InsightsPage() {
  return (
    <>
      <section className="page-hero page-hero--insights">
        <div className="shell page-hero__grid">
          <div>
            <p className="eyebrow eyebrow--light">Aquarium field notes</p>
            <h1>Design advice, emergency guidance, and local news.</h1>
          </div>
          <p>Practical guidance on aquarium emergencies, custom installations, planning, and the work behind healthy long-term systems.</p>
        </div>
      </section>
      <section className="section">
        <div className="shell article-grid article-grid--archive">
          {articles.map((article) => <ArticleCard key={article.slug} article={article} />)}
        </div>
      </section>
    </>
  )
}
